import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
export function AndromedaLanding() {
  return <main className="min-h-screen bg-[#0a0e1a] font-sans selection:bg-blue-500/30 selection:text-white overflow-x-hidden" data-id="element-143">
      <HeroSection data-id="element-144" />
      <OpeningHook data-id="element-145" />
      <ProblemSection data-id="element-146" />
      <MechanismSection data-id="element-147" />
      <WhatYouGet data-id="element-148" />
      <WhoIsItFor data-id="element-149" />
      <HowItWorks data-id="element-150" />
      <ProofSection data-id="element-151" />
      <FAQSection data-id="element-152" />
      <OfferSection data-id="element-153" />

      {/* Footer */}
      <footer className="py-8 text-center text-slate-600 border-t border-white/5" data-id="element-154">
        <p className="text-sm" data-id="element-155">
          © {new Date().getFullYear()} El Protocolo Andromeda. Todos los
          derechos reservados.
        </p>
      </footer>
    </main>;
}